import { render, staticRenderFns } from "./FollowPopup.vue?vue&type=template&id=0dda04bc&scoped=true&"
import script from "./FollowPopup.vue?vue&type=script&lang=js&"
export * from "./FollowPopup.vue?vue&type=script&lang=js&"
import style0 from "./FollowPopup.vue?vue&type=style&index=0&id=0dda04bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dda04bc",
  null
  
)

export default component.exports